<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <transition name="fade">
          <b-card no-body v-if="show">
            <div slot="header">
              <i class="fa fa-edit"></i> Settings
              <div class="card-header-actions">
                <b-link href="#" class="card-header-action btn-setting">
                  <i class="icon-settings"></i>
                </b-link>
                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                  <i class="icon-arrow-up"></i>
                </b-link>
                <b-link href="#" class="card-header-action btn-close" v-on:click="show = !show">
                  <i class="icon-close"></i>
                </b-link>
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <b-form-group
                  label="디바이스 로그 저장 여부"
                  :label-cols="3">
                  <c-switch class="mx-1" color="info" v-model="global.appLoggingEnable" label v-bind="labelIcon" />
                </b-form-group>
                <b-form-group
                  label="도난 장비 등록 허용 여부"
                  :label-cols="3">
                  <c-switch class="mx-1" color="info" v-model="global.serverRegisterStolenDeviceEnable"  label v-bind="labelIcon" />
                </b-form-group>                                
                <b-form-group
                  label="로그 보관 주기"
                  label-for="serverKeepLogSinceDay"
                  :label-cols="3">
                  <b-form-radio-group id="serverKeepLogSinceDay"
                    :plain="true"
                    :options="[
                      {text: '1개월',value: '30'},
                      {text: '3개월',value: '90'},
                      {text: '6개월',value: '180'},
                      {text: '12개월',value: '365'},
                    ]"
                    v-model="global.serverKeepLogSinceDay">
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group
                  label="마지막 로그인 후 미 사용 계정 휴면 전환"
                  label-for="serverKeepUnSignInUserSinceDay"
                  :label-cols="3">
                  <b-form-radio-group id="serverKeepUnSignInUserSinceDay"
                    :plain="true"
                    :options="[
                      {text: '1개월',value: '30'},
                      {text: '3개월',value: '90'},
                      {text: '6개월',value: '180'},
                      {text: '12개월',value: '365'},
                    ]"
                    v-model="global.serverKeepUnSignInUserSinceDay">
                  </b-form-radio-group>
                </b-form-group>   
                <b-form-group
                  label="휴면 계정 자동 삭제 주기"
                  label-for="serverKeepDisabledUserSinceDay"
                  :label-cols="3">
                  <b-form-radio-group id="serverKeepDisabledUserSinceDay"
                    :plain="true"
                    :options="[
                      {text: '1개월',value: '30'},
                      {text: '3개월',value: '90'},
                      {text: '6개월',value: '180'},
                      {text: '12개월',value: '365'},
                    ]"
                    v-model="global.serverKeepDisabledUserSinceDay">
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group
                  label="기기 미등록 계정 자동 삭제 주기"
                  label-for="serverKeepNoDeviceUserSinceDay"
                  :label-cols="3">
                  <b-form-radio-group id="serverKeepNoDeviceUserSinceDay"
                    :plain="true"
                    :options="[
                      {text: '1개월',value: '30'},
                      {text: '3개월',value: '90'},
                      {text: '6개월',value: '180'},
                      {text: '12개월',value: '365'},
                    ]"
                    v-model="global.serverKeepNoDeviceUserSinceDay">
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group
                  label="현황 카운트 초기화"
                  :label-cols="3">
                  <b-button type="submit" variant="primary" @click.stop="refreshStatistics">현 사용자/장비/그룹 카운트 초기화</b-button>&nbsp;
                </b-form-group>
                <b-form-group
                  label="최종 수정일"
                  label-for="updated"
                  :label-cols="3">
                  <b-form-input id="updated"
                    plaintext
                    v-model="lastUpdated">
                  </b-form-input>
                </b-form-group>
                <div class="form-actions">
                  <b-button type="submit" variant="primary" @click.stop="saveSettings">Save settings</b-button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import VueNotifications from 'vue-notifications'

export default {
  name: 'Settings',
  components: {
    cSwitch
  },  
  data () {
    return {
      global: {
        appLoggingEnable: true,
        serverRegisterStolenDeviceEnable: false,
        serverKeepLogSinceDay: 30,
        serverKeepUnSignInUserSinceDay: 365,
        serverKeepDisabledUserSinceDay: 365,
        serverKeepNoDeviceUserSinceDay: 30,
        updated: new Date(),
      },
      selected: [], // Must be an array reference!
      show: true,
      labelIcon: {
        dataOn: '\u2713',
        dataOff: '\u2715'
      },
      labelTxt: {
        dataOn: 'yes',
        dataOff: 'no'
      }      
    }
  },
  created: function() {
    console.debug('created()')
    this.$bind('global', this.$firebase.firestore().collection('settings').doc('global'))
  },
  computed: {
    lastUpdated() {
      return (this.global.updated && this.global.updated.seconds) ? (new Date(this.global.updated.seconds*1000)).toLocaleString(): ''
    }
  },
  methods: {
    async refreshStatistics() {
      await this.$http.get('/api/refreshStatisticsCurrent')
    },
    saveSettings() {
      this.global.updated = this.$firebase.firestore.FieldValue.serverTimestamp()
      console.info('saveSettings() :', this.global )
      this.$firebase.firestore().collection('settings').doc('global').update(this.global)
      .then( () => {
        this.$options.notifications.showInfoMsg.message = "Saved!"
        this.showInfoMsg()
      })
      .catch(error => {
        console.error('error in save', error)
        this.$options.notifications.showErrorMsg.message = error.message
        this.showErrorMsg()
      })
    },
    click () {
      // do nothing
    }
  },
  notifications: {
    showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Error',
        message: ''
    },
    showInfoMsg: {
        type: VueNotifications.types.info,
        title: 'Information',
        message: ''
    }
  }  
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
